var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewsFullSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,12.6142578c0-1.3027344-1.0175781-2.390625-2.3173828-2.4775391l-8.2324219-0.5478516l-3.5810547-8.3554688 C17.5488281,0.484375,16.8144531,0,16,0s-1.5488281,0.484375-1.8691406,1.2333984l-3.5810547,8.3554688l-8.2324219,0.5478516 C1.0175781,10.2236328,0,11.3115234,0,12.6142578c0,0.7011719,0.2978516,1.3730469,0.8173828,1.8408203l6.2304688,5.6376953 l-2.2138672,9.1689453c-0.0410156,0.1708984-0.0615234,0.3457031-0.0615234,0.5195312 C4.7724609,31.0048828,5.7675781,32,7.0839844,32c0.46875,0,0.9179688-0.1445312,1.2958984-0.4179688L16,26.0957031 l7.6191406,5.4853516C23.9980469,31.8554688,24.4472656,32,25.0087891,32c1.2236328,0,2.21875-0.9951172,2.21875-2.21875 c0-0.1738281-0.0205078-0.3486328-0.0625-0.5205078l-2.2128906-9.1679688l6.2294922-5.6367188 C31.7021484,13.9873047,32,13.3154297,32,12.6142578z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewsFullSmall);
export default __webpack_public_path__ + "static/media/reviews-full--small.4169e79088fc077dc35e021799955b93.svg";
export { ForwardRef as ReactComponent };